import React from 'react';
import { Icon } from './Icon';

export interface PlanLockPillProps {
    /** The cheapest plan that includes the feature, as the app names it
     *  («PRO»: `minPlanFor`), or a short fallback («De pago»). Caller owns i18n.
     *  Omitted: the lock alone, in the same circle — the side menu, where the
     *  name would crowd the entry (owner, 2026-10-25). Then the caller says
     *  what it means to a screen reader. */
    label?: string;
    className?: string;
}

/**
 * «🔒 PRO» — the small pill next to something the workshop's plan does not
 * include: a tab (`PageTabs` `lockLabel`), a settings entry, a «Primeros
 * pasos» task. Says WHICH plan has it; what clicking does is the caller's
 * (open an example, the upgrade hint, nothing). Pure presentation: the real
 * wall is the backend's `require_feature`.
 */
const PlanLockPill: React.FC<PlanLockPillProps> = ({ label, className = '' }) => (
    <span
        className={`inline-flex shrink-0 items-center rounded-full border border-primary/40 text-[10px] font-bold uppercase tracking-wide text-primary-dark dark:text-primary-light ${label ? 'gap-0.5 px-1.5 py-px' : 'h-[18px] w-[18px] justify-center'} ${className}`}
    >
        <Icon name="lock" className="!text-[11px]" aria-hidden="true" />
        {label}
    </span>
);

export default PlanLockPill;
